import { ref, isRef } from "vue";
import type { Ref } from "vue";

/**
 * @function useSetter - composable function to set a value,
 * works on any type of value, if ypu need to toggle a boolean useToggle works better
 * @param {Ref<unknown> | unknown} initialValue - a ref value to modify, if not passed the function returns the value
 * @return the toggler function, and a value if non were provided as parameter
 */
export default function useSetter(
  initialValue: Ref<unknown> | unknown = undefined
): {
  setter: (targetValue?: unknown) => void;
  value: Ref<unknown | undefined>;
} {
  /** value to toggle, if obtained as parameter change that, if a new value */
  const value: Ref<unknown> = isRef(initialValue)
    ? initialValue
    : ref(initialValue);
  /** function that toggles the flag*/
  const setter = (targetValue: unknown = undefined) => {
    value.value = targetValue;
  };

  return { value, setter };
}
